interface GraphNode {
  slug: string;
}

interface GraphEdge {
  source: string;
  target: string;
}

interface GraphData {
  nodes: GraphNode[];
  edges: GraphEdge[];
}

interface NeighborhoodNode extends GraphNode {
  focal: boolean;
  neighborLevel: number;
}

interface NeighborhoodResult {
  nodes: NeighborhoodNode[];
  edges: GraphEdge[];
  centerSlug: string;
}

export function extractNeighborhood(graphData: GraphData, centerSlug: string, depth: number): NeighborhoodResult {
  const adj = new Map<string, Set<string>>();
  for (const node of graphData.nodes) {
    adj.set(node.slug, new Set());
  }
  for (const edge of graphData.edges) {
    if (adj.has(edge.source)) adj.get(edge.source)!.add(edge.target);
    if (adj.has(edge.target)) adj.get(edge.target)!.add(edge.source);
  }

  const visited = new Map<string, number>();
  visited.set(centerSlug, 0);
  const queue = [centerSlug];

  while (queue.length > 0) {
    const current = queue.shift()!;
    const currentLevel = visited.get(current)!;
    if (currentLevel >= depth) continue;

    const neighbors = adj.get(current);
    if (!neighbors) continue;
    for (const neighbor of neighbors) {
      if (!visited.has(neighbor)) {
        visited.set(neighbor, currentLevel + 1);
        queue.push(neighbor);
      }
    }
  }

  const slugSet = new Set(visited.keys());

  const nodes: NeighborhoodNode[] = graphData.nodes
    .filter(n => slugSet.has(n.slug))
    .map(n => ({
      ...n,
      focal: n.slug === centerSlug,
      neighborLevel: visited.get(n.slug)!,
    }));

  const edges = graphData.edges.filter(
    e => slugSet.has(e.source) && slugSet.has(e.target)
  );

  return { nodes, edges, centerSlug };
}
